import { useState } from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';

import DocumentCard from './DocumentCard';
import useDocumentManagement from '../../../hooks/comptable/useDocumentManagement';
import {useNavigate} from "react-router-dom";

import DocumentsEnAttente from './DocumentsEnAttente';
import DocumentsClients from './DocumentsClients';
import ClassementDocuments from './ClassementDocuments';
import MesDocuments from './MesDocuments';
import LiensClients from './LiensClients';
import TypesDocuments from './TypesDocuments';
import DocumentSectionLayout from './../../../layouts/DocumentSectionLayout'

const componentMap = {
    docenattent: DocumentsEnAttente,
    docclient: DocumentsClients,
    docclasse: ClassementDocuments,
    mesdocuments: MesDocuments,
    lienclient: LiensClients,
    typedoc: TypesDocuments,
};

const DocumentManagementPage = () => {
    const { menuItems } = useDocumentManagement();
    const [selectedItem, setSelectedItem] = useState(null);
    const navigate = useNavigate();

    const handleCardClick = (title) => {
        const item = menuItems.find((item) => item.title === title);
        if (item) {
                       setSelectedItem(item);
                       // Si c'est le classement, on utilise la route dédiée
                           if (item.path === 'docclasse') {
                                navigate('/dashboard/documents/classement');
                                return;
                            }

                           // Sinon on reste en mode layout parent/enfant local
                               setSelectedItem(item);
        }
    };

    const handleBack = () => {
        setSelectedItem(null);
    };

    const SelectedComponent = selectedItem ? componentMap[selectedItem.path] : null;

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {selectedItem ? (
                <DocumentSectionLayout
                    title={selectedItem.title}
                    onBack={handleBack}
                    // right={}  // si un jour tu veux ajouter des actions à droite
                >
                    {SelectedComponent ? (
                        <SelectedComponent />
                    ) : (
                        <Typography>Composant non trouvé</Typography>
                    )}
                </DocumentSectionLayout>
            ) : (
                <Box>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{ fontWeight: 700, color: 'text.primary', fontSize: '20px' }}
                    >
                        Gestion Électronique des Documents
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ mb: 5 }}>
                        Optimisez votre efficacité, réduisez la paperasse et gagnez un temps précieux.
                    </Typography>
                    <Grid container spacing={4}>
                        {menuItems.map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <DocumentCard
                                    title={item.title}
                                    icon={item.icon}
                                    onClick={() => handleCardClick(item.title)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Container>
    );
};

export default DocumentManagementPage;